import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Department} from './resource/department';
import {BaseService} from '../../core/service/base.service';
import {Observable} from 'rxjs';
import {HeaderConstants} from '../../core/utils/headers.constants';
import {DepartmentLevel} from './resource/department-level';

@Injectable()
export class DepartmentLevelService {

  serviceUrl(): string {
    return `/api/department-levels`;
  }

  constructor(protected http: HttpClient) {
  }

  getAll(refresh = false): Observable<DepartmentLevel[]> {
    const paramsData = new HttpParams();
    const options = {params: paramsData, headers: new HttpHeaders().set(HeaderConstants.CACHED, refresh ? 'false' : 'true')};
    return this.http
      .get<DepartmentLevel[]>(`${this.serviceUrl()}/all`, options );
  }
}
